import React, { useState, useRef, useEffect } from 'react';
import {
  Grid,
  Divider,
  Typography,
  TextField,
  FormLabel,
  Box,
  Alert,
  Button,
  FormControl,
  Select,
  FormHelperText,
  MenuItem
} from '@mui/material';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { useBusinessEntityState, useHttpApi, useAppState } from 'state';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router';

const EditDocSubType = ({ handleEditClose, original }) => {
  const { updateDocumentSubType } = useHttpApi();
  const { enqueueSnackbar } = useSnackbar();
  const { throwErrorMessage } = useAppState();
  const { allDocumentTypes, fetchAllDocumentSubTypes } = useBusinessEntityState();
  const [error, setError] = useState('');
  const EditDocSubTypeSchema = Yup.object().shape({
    name: Yup.string().required('Document Sub Type Name is required'),
    document_type: Yup.object().required('Document Type is required')
  });
  const formik = useFormik({
    initialValues: original,
    validationSchema: EditDocSubTypeSchema,
    onSubmit: async (data, { resetForm }) => {
      console.log(data);
      try {
        console.log(JSON.stringify(data, null, ' '));
        const updatedData = {
          name: data.name,
          description: data.name,
          document_type: data.document_type.id
        };
        console.log(updatedData);
        const res = await updateDocumentSubType(data.id, updatedData);
        await fetchAllDocumentSubTypes();
        enqueueSnackbar('Updated Document Type Succesfully!', { variant: 'success' });
        handleEditClose();
      } catch (e) {
        throwErrorMessage(e);
      }
    }
  });
  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <>
      <Typography sx={{ fontWeight: 600 }}>Edit Document Sub Type</Typography>
      <Divider
        sx={{
          width: '100%',
          backgroundColor: '#f5f8fa',
          border: '2px solid #f5f8fa',
          my: 2
        }}
      />
      <FormikProvider value={formik}>
        <Form autoComplete="off" onSubmit={handleSubmit}>
          {error && (
            <Box mb={4}>
              <Alert
                severity="error"
                sx={{
                  textTransform: 'capitalize'
                }}
              >
                {error}
              </Alert>
            </Box>
          )}

          <Grid container spacing={4} sx={{ width: '100%' }}>
            <Grid item lg={12} md={6} sm={12} xs={12}>
              <FormLabel>Enter Document Sub Type</FormLabel>
              <TextField
                sx={{ mt: 1.5 }}
                fullWidth
                size="small"
                autoComplete="off"
                type="text"
                {...getFieldProps('name')}
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
              />
            </Grid>
            <Grid item lg={12} md={6} sm={12} xs={12} sx={{ mt: 1 }}>
              <FormLabel>Associate with a Document Type</FormLabel>

              <FormControl size="small" variant="outlined" fullWidth sx={{ mt: 1 }}>
                <Select
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  {...getFieldProps('document_type.id')}
                  error={Boolean(touched.document_type && errors.document_type)}
                  helperText={touched.document_type && errors.document_type}
                >
                  {allDocumentTypes.map((t) => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText sx={{ color: '#d32f2f' }}>
                  {touched.document_type && errors.document_type}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
          <Box display="flex" sx={{ mt: 1 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleEditClose}
              sx={{ width: '8rem', height: '2.5rem', mt: 2 }}
            >
              Cancel
            </Button>
            <LoadingButton
              sx={{
                width: '8rem',
                height: '2.5rem',
                mt: 2,
                ml: 2
              }}
              variant="gradient"
              loadingPosition="start"
              id="create-token"
              type="submit"
            >
              Edit
            </LoadingButton>
          </Box>
        </Form>
      </FormikProvider>
    </>
  );
};

export default EditDocSubType;
